import { BadgeCheck } from 'lucide-react';

/**
 * "Verified LXRA" badge. ALWAYS LXRA gold — never the studio accent — so
 * verification reads as an LXRA statement, not the photographer's branding.
 */
export const VerifiedBadge = ({ testId, size = 'sm', className = '' }) => (
  <span
    data-testid={testId}
    title="Verified by LXRA Studios"
    className={`inline-flex items-center gap-1 rounded-full border border-[#C9A45C]/45 bg-[#C9A45C]/10 text-[#D7B46A] font-medium uppercase tracking-[0.1em] shadow-[0_0_12px_rgba(201,164,92,0.15)] ${
      size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs'
    } ${className}`}
  >
    <BadgeCheck className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
    Verified LXRA
  </span>
);
